// extracted by mini-css-extract-plugin
export var list = "PortfolioList-module--list--JBGfq";
export var paginationContainer = "PortfolioList-module--paginationContainer--3Z6yi";